const getPublishedDataLoadingStatus = (rootState) => rootState.site.publishedDataLoaded;

export default getPublishedDataLoadingStatus;
